export const CATEGORIE_SERVIZI: string[] = [
  'E.01', 'E.05', 'E.14', 'E.17',
  'E.02', 'E.03', 'E.06', 'E.08', 'E.11', 'E.15', 'E.18', 'E.20',
  'E.09', 'E.12',
  'E.04', 'E.07', 'E.10', 'E.13', 'E.16', 'E.19', 'E.21',
  'E.22',
  'S.01', 'S.02', 'S.03', 'S.04', 'S.05', 'S.06',
  'IA.01', 'IA.02', 'IA.03', 'IA.04',
  'IB.04', 'IB.05', 'IB.06', 'IB.07', 'IB.08', 'IB.09', 'IB.10', 'IB.11', 'IB.12',
  'V.01', 'V.02', 'V.03',
  'D.01', 'D.02', 'D.03', 'D.04', 'D.05',
  'T.01', 'T.02', 'T.03',
  'P.01', 'P.02', 'P.03', 'P.04', 'P.05', 'P.06',
  'U.01', 'U.02', 'U.03'
];

